module.exports = "/group_active@2x-adcc9101e16d0735293f85bec6fc7fc7.png";